import finalCatalog from './finalCemeteryCatalog.json';
import { buildCatalogSync as buildPlan } from './catalogSyncCore.mjs';
export { referenceCount, normalize, nameOf } from './catalogSyncCore.mjs';

export function buildCatalogSync(cities, cemeteries, references) {
  return buildPlan(cities, cemeteries, references, finalCatalog);
}
